import { render, staticRenderFns } from "./PaymentCallback.vue?vue&type=template&id=3d2abc8d&scoped=true"
import script from "./PaymentCallback.vue?vue&type=script&lang=js"
export * from "./PaymentCallback.vue?vue&type=script&lang=js"
import style0 from "./PaymentCallback.vue?vue&type=style&index=0&id=3d2abc8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2abc8d",
  null
  
)

export default component.exports